export function domReady() {
  if (typeof document === 'undefined' || document.readyState !== 'loading') return Promise.resolve();
  return new Promise((resolve) => {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      resolve();
    });
  });
}

export function pageLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined' || document.readyState === 'complete') {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad);
      resolve();
    });
  });
}
